const Vue = require('vue')

const parse = (v) => {
    if (v === null) {
        return null
    }

    return !!v
}

Vue.component('form-nullable-check', {
    props: {
        label: {
            twoWay: true,
            type: String
        },
        model: {
            twoWay: true,
            default: null
        },
        compact: {
            default: false
        },
        onChange: {
            type: Function,
            default: () => {
            }
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            fieldName: '',
            hovered: false
        }
    },
    ready () {
        this.fieldName = this._props.model.raw
    },
    methods: {
        changed (evt) {
            if (this.onChange) {
                this.onChange(evt.target.checked)
            }
        },

        toggle () {
            if (this.model === false) {
                this.model = null
            } else {
                this.model = !this.model
            }
        },

        showTooltip () {
            this.hovered = true
        },

        hideTooltip () {
            this.hovered = false
        }
    },
    computed: {
        text () {
            switch (parse(this.model)) {
                case true:
                    return 'S'
                case false:
                    return 'N'
                default:
                    return '&nbsp;'
            }
        },
        tooltip () {
            switch (parse(this.model)) {
                case true:
                    return 'Sim'
                case false:
                    return 'Não'
                default:
                    return 'Indiferente'
            }
        },
        checkClass () {
            switch (parse(this.model)) {
                case true:
                    return 'true'
                case false:
                    return 'false'
                default:
                    return 'null'
            }
        }
    },
    watch: {},
    template: `
            <div class="form-group nullable-check-holder" style="position: relative">
                <label @mouseenter="showTooltip()" @mouseleave="hideTooltip()">
                    <div v-if="hovered" class="tooltip fade top in" role="tooltip" style="display: block; top: -35px; transform: translateX(-50%); left: 10px;">
                        <div class="tooltip-arrow" style="left: 50%;"></div>
                        <div class="tooltip-inner">{{tooltip}}</div>
                    </div>
                    <button type="button" class="nullable-check" :class="checkClass" @focus="showTooltip()" @blur="hideTooltip()" @click.prevent="toggle()">
                        {{{ text }}}
                    </button>
                    {{{ label }}}
                </label>
            </div>
        `
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/form/nullable-check.js